import React from "react";
import { useVSU } from "../store";
import { pick, clampRange } from "../helpers";

// Единый тулбар органов управления (5.3, RQ.02.04/RQ.02.05).
// Значения фильтров — стабильные ключи (_ru): выбор сохраняется при смене языка,
// а подпись пункта отображается на текущем языке.
export default function FiltersToolbar() {
  const {
    t,
    lang,
    meta,
    dateKind,
    setDateKind,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    filterSource,
    setFilterSource,
    filterAddress,
    setFilterAddress,
    filterLocation,
    setFilterLocation,
    resetFilters,
    summary,
  } = useVSU();

  const bounds = meta?.date_bounds?.[dateKind] ?? { min: null, max: null };

  const onFrom = (e) => {
    const { from, to } = clampRange(e.target.value, dateTo, "from");
    setDateFrom(from);
    setDateTo(to);
  };
  const onTo = (e) => {
    const { from, to } = clampRange(dateFrom, e.target.value, "to");
    setDateFrom(from);
    setDateTo(to);
  };

  // Выпадающий список фильтра-разреза. value = стабильный ключ _ru, подпись — текущий язык.
  const Select = ({ options, value, onChange }) => (
    <select
      className="vsu-select"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">{t("all")}</option>
      {(options ?? []).map((o) => (
        <option key={o.ru} value={o.ru}>
          {pick(o, lang)}
        </option>
      ))}
    </select>
  );

  return (
    <div className="vsu-controls">
      <div className="vsu-ctrl-group">
        <span className="vsu-ctrl-label">{t("term")}</span>
        <div className="vsu-typeset">
          <button
            className={"vsu-typebtn" + (dateKind === "plan" ? " active" : "")}
            onClick={() => setDateKind("plan")}
          >
            {t("tPlan")}
          </button>
          <button
            className={"vsu-typebtn" + (dateKind === "fact" ? " active" : "")}
            onClick={() => setDateKind("fact")}
          >
            {t("tFact")}
          </button>
        </div>
      </div>

      <div className="vsu-ctrl-group">
        <span className="vsu-ctrl-label">{t("from")}</span>
        <input
          type="date"
          className="vsu-select vsu-date"
          value={dateFrom}
          min={bounds.min || undefined}
          max={bounds.max || undefined}
          onChange={onFrom}
        />
        <span className="vsu-ctrl-label">{t("to")}</span>
        <input
          type="date"
          className="vsu-select vsu-date"
          value={dateTo}
          min={bounds.min || undefined}
          max={bounds.max || undefined}
          onChange={onTo}
        />
      </div>

      <div className="vsu-ctrl-group">
        <span className="vsu-ctrl-label">{t("fSrc")}</span>
        <Select
          options={meta?.sources}
          value={filterSource}
          onChange={setFilterSource}
        />
      </div>
      <div className="vsu-ctrl-group">
        <span className="vsu-ctrl-label">{t("fAddr")}</span>
        <Select
          options={meta?.addresses}
          value={filterAddress}
          onChange={setFilterAddress}
        />
      </div>
      <div className="vsu-ctrl-group">
        <span className="vsu-ctrl-label">{t("fLoc")}</span>
        <Select
          options={meta?.locations}
          value={filterLocation}
          onChange={setFilterLocation}
        />
      </div>

      <button className="vsu-reset" onClick={resetFilters}>
        {t("reset")}
      </button>

      {/* Счётчик результата ФИЛЬТРАЦИИ (summary.total). На строку поиска не реагирует (5.3). */}
      <div className="vsu-found">
        {t("found")}: <b>{summary ? summary.total : "—"}</b> {t("foundUnit")}
      </div>
    </div>
  );
}
